import type { PropsWithChildren } from 'react';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import { useWidgetRect } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { colors } from './helpers';

export function ThemeProvider({ children }: PropsWithChildren) {
  const settings = useSettings();
  const widgetRect = useWidgetRect();
  const colorsStyle = colors(settings);

  return (
    <SCThemeProvider
      theme={{
        ...settings,
        windowWidth: widgetRect?.width,
        colorsStyle
      }}
    >
      {children}
    </SCThemeProvider>
  );
}
